import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import { GetAllNoHideSubsnameList } from "../../../../Api/ServiceDatas";
import { ISunsetFilter } from "../../../../pages/Manage/Sunset/Sunset";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { GetAllNoHideSubsnameListv3 } from "../../../../ApiTS/ServiceDatasTS_V3";

interface SunsetFilterProps {
  sunsetFilter: ISunsetFilter;
  setSunsetFilter: Dispatch<SetStateAction<ISunsetFilter>>;
}

export default function SunsetFilter({
  sunsetFilter,
  setSunsetFilter,
}: SunsetFilterProps) {
  const [filterList, setFilterList] = useState<
    { value: string; label: string }[]
  >([]);
  const [filterTypeDropdownValue, setFilterTypeDropdownValue] =
    useState<OptionType>({
      value: "",
      label: "선택",
    });
  const [filterDropdownValue, setFilterDropdownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });

  const filterTypeOptionList = [
    { value: "isexec", label: "일몰 상태" },
    { value: "srisesubs", label: "신규 전환 서비스" },
  ];

  useEffect(() => {
    if (filterTypeDropdownValue?.value === "srisesubs") {
      const subsOptionList = [];
      const subsNameList = GetAllNoHideSubsnameListv3();

      for (let i = 0; i < subsNameList.length; i++) {
        const e = subsNameList[i];

        subsOptionList.push({ value: e?.split("_")[0], label: e });
      }

      setFilterList(subsOptionList);
    } else if (filterTypeDropdownValue?.value === "isexec") {
      setFilterList([
        { value: "0", label: "예정" },
        { value: "1", label: "왼료" },
        { value: "2", label: "취소" },
      ]);
    }
  }, [filterTypeDropdownValue]);

  return (
    <Flex gapSize={10}>
      <FilterIcon />

      {/* filter type */}
      <DropDown
        isDisabled={false}
        dropdownValue={filterTypeDropdownValue}
        setDropDownValue={setFilterTypeDropdownValue}
        boxWidth={180}
        optionList={filterTypeOptionList}
      />

      {/* filter 내용 */}
      <DropDown
        isDisabled={filterTypeDropdownValue?.value === ""}
        dropdownValue={filterDropdownValue}
        setDropDownValue={setFilterDropdownValue}
        boxWidth={220}
        optionList={filterList}
      />

      <ConfirmBtn
        btnText="적용"
        btnColor="mint"
        btnHeight={38}
        isDisabled={filterDropdownValue?.value === ""}
        btnClickEvent={() => {
          setSunsetFilter({
            type: filterTypeDropdownValue?.value ?? "",
            value: filterDropdownValue?.value ?? "",
          });
        }}
      />

      <LineBtn
        btnText="초기화"
        icon="refresh"
        btnHeight={38}
        btnColor="mint"
        disabled={
          filterTypeDropdownValue?.value === "" &&
          filterDropdownValue?.value === ""
        }
        btnClickEvent={() => {
          setFilterTypeDropdownValue({
            value: "",
            label: "선택",
          });
          setFilterDropdownValue({
            value: "",
            label: "선택",
          });
          setSunsetFilter({
            type: "",
            value: "",
          });
        }}
      />
    </Flex>
  );
}
